export const ACTIONS = {
	SET_EXTENSION_DATA: 'SET_EXTENSION_DATA',
	SET_LONG_ID: 'SET_LONG_ID',
	SET_LIST_URL: 'SET_LIST_URL',
	SET_ENV: 'SET_ENV',
	SET_SDK: 'SET_SDK',
	SET_SDK_STATE: 'SET_SDK_STATE',
	ADD_COMPONENT: 'ADD_COMPONENT',
	REMOVE_COMPONENT: 'REMOVE_COMPONENT',
	MOUNT_COMPONENTS: 'MOUNT_COMPONENTS',
	PAY: 'PAY',
	SET_ACTIVE_PAYMENT_METHOD: 'SET_ACTIVE_PAYMENT_METHOD',
	SET_FORCE_HOSTED_FLOW: 'SET_FORCE_HOSTED_FLOW',
	SET_IS_VALID: 'SET_IS_VALID'
};
